import { render, staticRenderFns } from "./submitWork.vue?vue&type=template&id=45dcfbc8&scoped=true"
import script from "./submitWork.vue?vue&type=script&lang=js"
export * from "./submitWork.vue?vue&type=script&lang=js"
import style0 from "./submitWork.vue?vue&type=style&index=0&id=45dcfbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcfbc8",
  null
  
)

export default component.exports